module.exports = __webpack_public_path__ + "static/about-investition9-b33bffd943720458567f93c2b6cb2f1f.jpg";